export const manifest = {
  screens: {
    scr_hdu50e: { name: "Home & claim type", route: "/", position: {"x":160,"y":3800} },
    scr_57849w: { name: "Calculator — Your details", route: "/", state: {"calculatorStep":1,"calculatorClaimType":"road"}, position: {"x":160,"y":1820} },
    scr_rx1u9e: { name: "Road — Accident details", route: "/", state: {"calculatorStep":2,"calculatorClaimType":"road"}, position: {"x":1560,"y":1820} },
    scr_ahmxli: { name: "Road — Injuries & work", route: "/", state: {"calculatorStep":3,"calculatorClaimType":"road"}, position: {"x":2960,"y":1820} },
    scr_2ifpse: { name: "Road — Claim & documents", route: "/", state: {"calculatorStep":4,"calculatorClaimType":"road"}, position: {"x":4360,"y":1820} },
    scr_2rlk95: { name: "Work — Accident details", route: "/", state: {"calculatorStep":2,"calculatorClaimType":"work"}, position: {"x":160,"y":5780} },
    scr_u5x8bn: { name: "Work — Injuries & work", route: "/", state: {"calculatorStep":3,"calculatorClaimType":"work"}, position: {"x":1560,"y":5780} },
    scr_oblxwk: { name: "Work — Claim & documents", route: "/", state: {"calculatorStep":4,"calculatorClaimType":"work"}, position: {"x":2960,"y":5780} },
    scr_8r9a6k: { name: "Public liability — Accident", route: "/", state: {"calculatorStep":2,"calculatorClaimType":"public"}, position: {"x":160,"y":7760} },
    scr_wscsui: { name: "Public liability — Injuries", route: "/", state: {"calculatorStep":3,"calculatorClaimType":"public"}, position: {"x":1560,"y":7760} },
    scr_lozto7: { name: "Public liability — Documents", route: "/", state: {"calculatorStep":4,"calculatorClaimType":"public"}, position: {"x":2960,"y":7760} },
    scr_ft59ps: { name: "Other — Incident details", route: "/", state: {"calculatorStep":2,"calculatorClaimType":"other"}, position: {"x":160,"y":9740} },
    scr_ra36y8: { name: "Other — Injuries & work", route: "/", state: {"calculatorStep":3,"calculatorClaimType":"other"}, position: {"x":1560,"y":9740} },
    scr_f074wq: { name: "Other — Documents", route: "/", state: {"calculatorStep":4,"calculatorClaimType":"other"}, position: {"x":2960,"y":9740} },
  },
  sections: {
    sec_srhmjm: { name: "Claim Calculator", x: 0, y: 1600, width: 5720, height: 1180 },
    sec_ny87rt: { name: "Claim Type Selection", x: 0, y: 3580, width: 1520, height: 1180 },
    sec_jtkhry: { name: "Work Claim Flow", x: 0, y: 5560, width: 4320, height: 1180 },
    sec_tlc8ia: { name: "Public Liability Claim Flow", x: 0, y: 7540, width: 4320, height: 1180 },
    sec_6gjj0r: { name: "Other Claim Flow", x: 0, y: 9520, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_srhmjm", children: [
      { kind: "screen", id: "scr_57849w" },
      { kind: "screen", id: "scr_rx1u9e" },
      { kind: "screen", id: "scr_ahmxli" },
      { kind: "screen", id: "scr_2ifpse" },
    ] },
    { kind: "section", id: "sec_ny87rt", children: [
      { kind: "screen", id: "scr_hdu50e" },
    ] },
    { kind: "section", id: "sec_jtkhry", children: [
      { kind: "screen", id: "scr_2rlk95" },
      { kind: "screen", id: "scr_u5x8bn" },
      { kind: "screen", id: "scr_oblxwk" },
    ] },
    { kind: "section", id: "sec_tlc8ia", children: [
      { kind: "screen", id: "scr_8r9a6k" },
      { kind: "screen", id: "scr_wscsui" },
      { kind: "screen", id: "scr_lozto7" },
    ] },
    { kind: "section", id: "sec_6gjj0r", children: [
      { kind: "screen", id: "scr_ft59ps" },
      { kind: "screen", id: "scr_ra36y8" },
      { kind: "screen", id: "scr_f074wq" },
    ] },
  ],
}
